/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Requirement_UndoInputs */

const en_task_requirement_undo = /** @type {(inputs: Task_Requirement_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo`)
};

const pt_br2_task_requirement_undo = /** @type {(inputs: Task_Requirement_UndoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverter`)
};

/**
* | output |
* | --- |
* | "Undo" |
*
* @param {Task_Requirement_UndoInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_requirement_undo = /** @type {((inputs?: Task_Requirement_UndoInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Requirement_UndoInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_requirement_undo(inputs)
	return pt_br2_task_requirement_undo(inputs)
});